import { useState } from "react";
import { Gallery } from "react-grid-gallery";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

export default function SimpleGallery(props) {
  const [index, setIndex] = useState(-1);
  const {images} = props

  const slides = images.map(({ src, width, height }) => ({
    src,
    width,
    height,
  }));
  const handleClick = (index, item) => setIndex(index);

  return (
    <div>
      <Gallery
        rowHeight={350}
        images={images}
        onClick={handleClick}
        enableImageSelection={false}
        margin={4}
      />
      <Lightbox
        slides={slides}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
      />
    </div>
  );
}